import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcinputComponent } from '../fcinput';
/**
 * fc-avatarå¤´å
 * å¤´åç»ä»¶ã
 * ç¨æ¥ä»£è¡¨ç¨æ·æäºç©ï¼æ¯æå¾çãå¾æ æå­ç¬¦å±ç¤ºã
 */
@Component({
    selector: 'fc-avatar',
    template: `
    <ng-container *ngIf="fcCount===undefined">
    <nz-avatar nzIcon="user"></nz-avatar>
    </ng-container>
    <ng-container *ngIf="fcCount!==undefined">
        <nz-badge [nzCount]="_count" nz-tooltip [nzTitle]="fcToolTip">
        <nz-avatar nzIcon="user"></nz-avatar>
        </nz-badge>
    </ng-container>
    `,
    styles: [`
    .fc-avatar{
    }
    `]
})
export class FcavatarComponent extends FcinputComponent {
     /** æç¤ºæ é¢*/
    @Input()
    fcToolTip: string;
     /**é¢è²*/
    @Input()
    fcColor: string;
     /**èæ¯é¢è²*/
    @Input()
    fcBgColor: string;
     /**å¸¦å¾½ç« çå¤´å*/
    @Input()
    fcCount: string;
    _count:number;
     /**è®¾ç½®å¤´åçå¾æ ç±»å*/
    @Input()
    fcIcon: string;
     /**æå®å¤´åçå½¢ç¶ï¼ä¸¤ç§å½¢ç¶å¯éã*/
    @Input()
    fcShape: string;
     /**æ¯æä¸ç§ç±»åï¼å¾çãIcon ä»¥åå­ç¬¦ï¼å¶ä¸­ Icon åå­ç¬¦åå¯ä»¥èªå®ä¹å¾æ é¢è²åèæ¯è²ã*/
     /**å¾çç±»å¤´åçèµæºå°åï¼åè¥å¾çå è½½å¤±è´¥ï¼èªå¨æ¾ç¤º nzIcon > nzText*/
     /**å­ç¬¦å*/
    @Input()
    fcText: string;
     /**å¤§å°ï¼å¤´åæä¸ç§å°ºå¯¸*/
    @Input()
    fcSize: string;
     /** ä¸»å¯¹è±¡å¼*/
    mainObj: any = {};
    @Input()
    fcSrc: string;
    constructor(public provider: ProvidersService) {
        super(provider,'fc-avatar');
    }
    _afterParentInit() {
         /**é»è®¤å½¢ç¶ä¸ºåå½¢*/
        if (this.fcShape === undefined && this.fcCount === undefined) {
            this.fcShape = "circle";
        } else if (this.fcShape === "fcsquare") {
            this.fcShape = "square";
        }
         /**æå­ç¬¦ä¸²è½¬ææ°å­*/
        if (this.fcCount !== undefined) {
            this._count = parseInt(this.fcCount)
            this.fcShape = "square";
        }
         /**fcIcon fcText  fcSrc é½ä¸ºundefinedæ¶æ¥é*/
        if (this.fcIcon === undefined && this.fcText === undefined && this.fcSrc === undefined) {
            throw new Error("è³å°ä¼ å¥ä¸ä¸ªå¾æ ãææ¬ãå¾ç");
        }
    }
}

